import './spinner.css'
export default function SpinnerLoader({className=''}:any) {
    return (
        <div className={`xbox-load spinner ${className}`}>
            <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )
}